import { render, staticRenderFns } from "./ValueTag.vue?vue&type=template&id=1bbab0b5&scoped=true&"
import script from "./ValueTag.vue?vue&type=script&lang=js&"
export * from "./ValueTag.vue?vue&type=script&lang=js&"
import style0 from "./ValueTag.vue?vue&type=style&index=0&id=1bbab0b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbab0b5",
  null
  
)

export default component.exports